export default __webpack_public_path__ + "static/media/navbar-reports-dark.ea826a9c.svg";